module.exports = __webpack_public_path__ + "static/media/questions.b0bf8a28.svg";